import React from 'react';
import PropTypes from 'prop-types';

const PaymentStatusInfoItem = ({
  paymentStatusInfoDetails,
  invoiceDetails = null,
  paymentReferenceDetails = null,
}) => {
  return (
    <>
      <div>{paymentStatusInfoDetails}</div>
      <br />
      {invoiceDetails && (
        <div>
          Invoice: <span style={{ fontWeight: 'bold' }}>{invoiceDetails}</span>
        </div>
      )}
      <br />
      {paymentReferenceDetails && (
        <div>
          PaymentReference: <span style={{ fontWeight: 'bold' }}>{paymentReferenceDetails}</span>
        </div>
      )}
    </>
  );
};

PaymentStatusInfoItem.propTypes = {
  paymentStatusInfoDetails: PropTypes.string.isRequired,
  invoiceDetails: PropTypes.string,
  paymentReferenceDetails: PropTypes.string,
};

PaymentStatusInfoItem.defaultProps = {
  invoiceDetails: null,
  paymentReferenceDetails: null,
};

export default PaymentStatusInfoItem;
